var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.332 8.036C3.332 6.54262 4.54262 5.332 6.036 5.332H17.964C19.4574 5.332 20.668 6.54262 20.668 8.036V19.42C20.668 20.1093 20.1093 20.668 19.42 20.668H4.58C3.89075 20.668 3.332 20.1093 3.332 19.42V8.036Z",
    stroke: "#2E2E30",
    strokeWidth: 1.664
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H21",
    stroke: "#2E2E30",
    strokeWidth: 1.664
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3V5",
    stroke: "#2E2E30",
    strokeWidth: 1.664,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3V5",
    stroke: "#2E2E30",
    strokeWidth: 1.664,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12.5,
    width: 2.2,
    height: 2,
    fill: "#2E2E30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2998,
    y: 12.5,
    width: 2.2,
    height: 2,
    fill: "#2E2E30"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9004,
    y: 12.5,
    width: 2.2,
    height: 2,
    fill: "#2E2E30"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 16.5,
    width: 2.2,
    height: 2,
    fill: "#2E2E30"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2998,
    y: 16.5,
    width: 2.2,
    height: 2,
    fill: "#2E2E30"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9004,
    y: 16.5,
    width: 2.2,
    height: 2,
    fill: "#2E2E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingCalander);
export default __webpack_public_path__ + "static/media/ic_setting_calander.01e01423dbbba6bd7069b1b3a2c8a2c2.svg";
export { ForwardRef as ReactComponent };